import styles from "../v2/RatingBarv2.scss";
import PropTypes from "prop-types";
import { getAriaLabel } from "../../../utils/ratingsAriaLabels";
import { useRuntimeConstants } from "../../../context/runtimeConstants/RuntimeConstantsContext";

const RatingBar = ({ percentage, minLabel, midLabel, maxLabel, label }) => {
  const {
    getTranslation,
    webContext: { browseCountry },
  } = useRuntimeConstants();

  const isDK = browseCountry === "DK";

  return (
    <div
      aria-label={getAriaLabel(getTranslation, {
        label,
        minLabel,
        midLabel,
        maxLabel,
        percentage,
      })}
      role="img"
    >
      <div
        className={styles.ratingBar}
        data-testid="ratingBar"
        aria-hidden={true}
      >
        <div
          className={styles.ratingProgress}
          style={{ left: `${percentage}%` }}
        />
      </div>
      <div
        className={styles.ratingsLabels}
        data-testid="ratingLabels"
        aria-hidden={true}
      >
        <div className={isDK ? styles.dkMinLabel : ""}>{minLabel}</div>
        {midLabel && (
          <div
            className={`${styles.ratingsLabelMid} ${
              isDK ? styles.dkMidLabel : ""
            }`}
          >
            {midLabel}
          </div>
        )}
        <div
          className={`${styles.ratingsLabelMax} ${
            isDK ? styles.dkMaxLabel : ""
          }`}
        >
          {maxLabel}
        </div>
      </div>
    </div>
  );
};

export default RatingBar;

RatingBar.propTypes = {
  percentage: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  minLabel: PropTypes.string.isRequired,
  midLabel: PropTypes.string,
  maxLabel: PropTypes.string.isRequired,
};
